import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isElectron } from '../utils/electron';
import useSpaceStore from '../stores/spaceStore';

export function useQuickEntryContextPush() {
  const location = useLocation();
  const activeSpace = useSpaceStore((s) => s.activeSpace);

  useEffect(() => {
    if (!isElectron()) return;
    const pushContext = (window as any).riverOS?.quickEntry?.pushContext;
    if (!pushContext) return;

    // Extract spaceId from /spaces/:id routes
    const spaceMatch = location.pathname.match(/\/spaces\/([^/?#]+)/);
    const spaceId = spaceMatch?.[1] ?? null;

    // Include name only when the active space matches the current URL
    const spaceName =
      spaceId && spaceId === activeSpace?.id ? (activeSpace?.name ?? null) : null;

    const ctx = {
      spaceId,
      spaceName,
      pathname: location.pathname,
      pushedAt: Date.now(),
    };

    pushContext(ctx);
  }, [location.pathname, activeSpace?.id, activeSpace?.name]);
}
